/** Part of a free text: plain text, or a phone number with the number to dial */
export interface PhoneTextPart {
  text: string;
  /** Number for a tel: link (separators removed), only on phone number parts */
  phone?: string;
}

/**
 * Phone numbers in free text: 7-15 digits in total, either "+" and digits or digits starting with 0
 * (the leading 0 counts as one of the digits), optionally separated by single spaces or hyphens.
 * "+358 40 123 4567", "040-123 4567", "09 123 4567", "+46 70 123 45 67".
 * Not part of a longer word or number, so a social security number like 010190-123A is not matched.
 * Dots are not separators, so dates like 01.01.2026 are not matched either.
 */
const PHONE_NUMBER = /(?<![\w+])(?:\+\d|0)(?:[ -]?\d){6,14}(?![\w+])/g;

/** Split free text into plain text and phone number parts */
export function splitPhoneNumbers(text: string): PhoneTextPart[] {
  if (!text) {
    return [];
  }

  const parts: PhoneTextPart[] = [];
  let last = 0;
  for (const match of text.matchAll(PHONE_NUMBER)) {
    const start = match.index ?? 0;
    if (start > last) {
      parts.push({ text: text.slice(last, start) });
    }
    parts.push({ text: match[0], phone: match[0].replace(/[ -]/g, "") });
    last = start + match[0].length;
  }
  if (last < text.length) {
    parts.push({ text: text.slice(last) });
  }
  return parts;
}
